import OnlineOrderingView from './OnlineOrderingView';

export default {
  OnlineOrderingView,
};
